
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "Major_salivary_gland_tumor",
components: {
XTable
}
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/Major_salivary_gland_tumor.vue